export default __webpack_public_path__ + "static/media/checkMark.c0a7300c.svg";